import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { modalActions } from "../ModalSlice";
import { JEDI_HR_URL } from "../../constants";
import axiosClient from "../../utils/axiosClient";
import axios from "axios";

export const getAllTaskboxItems = createAsyncThunk(
    "taskbox/get_all_change_request",
    async (payload, { dispatch, getState, rejectWithValue }) => {
        dispatch(loadingActions.setLoading(true));

        console.log("\n\nInside getAllTaskboxRequests : ", payload);

        const baseURL = "https://" + JEDI_HR_URL;

        const path = "/get_all_change_request";
        const url = baseURL + path;
        try {
            const response = await axiosClient.post(url, payload);

            dispatch(loadingActions.setLoading(false));
            console.log("getAllTaskboxRequests response : ", response.data);

            if (response.data.status === "error") {
                dispatch(
                    modalActions.setErrorModal({
                        message:
                            "Error :" +
                            (response?.data?.message || response?.data?.error_message),
                        status: "error",
                        state: true,
                    })
                );
                return rejectWithValue(
                    response?.data?.error_message || response?.data?.message
                );
            }

            return response.data;
        } catch (error) {
            console.log("Error getAllTaskboxRequests : ", error.message);

            dispatch(loadingActions.setLoading(false));
            dispatch(
                modalActions.setErrorModal({
                    message: error?.message,
                    status: error.status,
                    state: true,
                })
            );
            return rejectWithValue(error);
        }
    }
);

export const approveTaskRequestChange = createAsyncThunk(
    "taskbox/approve_change_request",
    async (payload, { dispatch, getState, rejectWithValue }) => {
        dispatch(loadingActions.setLoading(true));

        console.log("\n\nInside approveTaskRequestChange : ", payload);

        const baseURL = "https://" + JEDI_HR_URL;

        const path = "/approve_change_request";
        const url = baseURL + path;
        try {
            const response = await axiosClient.post(url, payload);

            dispatch(loadingActions.setLoading(false));
            console.log("approveTaskRequestChange response : ", response.data);

            if (response.data.status === "error") {
                dispatch(
                    modalActions.setErrorModal({
                        message:
                            "Error :" +
                            (response?.data?.message || response?.data?.error_message),
                        status: "error",
                        state: true,
                    })
                );
                return rejectWithValue(
                    response?.data?.error_message || response?.data?.message
                );
            }

            return response.data;
        } catch (error) {
            console.log("Error approveTaskRequestChange : ", error.message);

            dispatch(loadingActions.setLoading(false));
            dispatch(
                modalActions.setErrorModal({
                    message: error?.message,
                    status: error.status,
                    state: true,
                })
            );
            return rejectWithValue(error);
        }
    }
);

export const generatePresignedURL = createAsyncThunk(
    "taskbox/generate_presigned_url",
    async (data, { dispatch, getState, rejectWithValue }) => {
        let payload = data.payload;
        let file = data.file;

        dispatch(loadingActions.setLoading(true));

        console.log("\n\nInside getPresignedURL : ", payload);

        const baseURL = "https://" + JEDI_HR_URL;

        const path = "/generate_presigned_url";
        const url = baseURL + path;
        try {
            const response = await axiosClient.post(url, payload);

            // dispatch(loadingActions.setLoading(false));
            console.log("getPresignedURL response : ", response.data);

            if (response.data.status === "error") {
                dispatch(loadingActions.setLoading(false));
                dispatch(
                    modalActions.setErrorModal({
                        message:
                            "Error : " +
                            (response?.data?.message || response?.data?.error_message),
                        status: "error",
                        state: true,
                    })
                );
                return rejectWithValue(
                    response?.data?.error_message || response?.data?.message
                );
            } else if (response.data?.status === "success") {
                const presigned_url = response.data?.presigned_url?.url;

                const formData = new FormData();

                Object.entries(response.data?.presigned_url?.fields).forEach(
                    ([key, value]) => {
                        formData.append(key, value);
                    }
                );

                formData.append("file", file);

                console.log("\n\n\n\nFormdata : ", formData);

                try {
                    const uploadResponse = await axios.post(
                        presigned_url,
                        formData
                        // {
                        //     headers: { "Content-Type": "multipart/form-data" },
                        // }
                    );

                    console.log("upload ", uploadResponse);

                    dispatch(loadingActions.setLoading(false));

                    if (uploadResponse.status === 204) {
                        console.log("File uploaded successfully!");
                        // this is just for the bulk upload
                        if (payload.key == "bulk_upload") {
                            const newPayload = { "key": response.data?.presigned_url?.fields?.key }
                            console.log("\n\nInside bulk_upload : ", newPayload);
                            const baseURL = "https://" + JEDI_HR_URL;

                            const path = "/upload_bulk_user_template";
                            const url = baseURL + path;

                            try {
                                const response = await axiosClient.post(url, newPayload)
                                console.log("bulk_upload response", response)
                                dispatch(loadingActions.setLoading(false));
                                if (response.data.status === "error") {
                                    dispatch(
                                        modalActions.setErrorModal({
                                            message:
                                                "Error : " +
                                                (response?.data?.message || response?.data?.error_message),
                                            status: "error",
                                            state: true,
                                        })
                                    );
                                    return rejectWithValue(
                                        response?.data?.error_message || response?.data?.message
                                    );
                                }
                                return response.data;
                            } catch (error) {
                                console.log("Error getAllReportees : ", error.message);

                                dispatch(loadingActions.setLoading(false));
                                dispatch(
                                    modalActions.setErrorModal({
                                        message: error?.message,
                                        status: error.status,
                                        state: true,
                                    })
                                );
                                return rejectWithValue(error);
                            }

                        }
                    } else {
                        console.error("Upload failed:", uploadResponse);
                        return rejectWithValue(
                            uploadResponse?.data?.error_message ||
                            uploadResponse?.data?.message
                        );
                    }
                } catch (error) {
                    console.error("Error uploading file:", error);
                    dispatch(loadingActions.setLoading(false));
                    dispatch(
                        modalActions.setErrorModal({
                            message: error?.message,
                            status: error.status,
                            state: true,
                        })
                    );
                }
                return response.data;
            }
        } catch (error) {
            console.log("Error get_presigned_url : ", error.message);

            dispatch(loadingActions.setLoading(false));
            dispatch(
                modalActions.setErrorModal({
                    message: error?.message,
                    status: error.status,
                    state: true,
                })
            );
            return rejectWithValue(error);
        }
    }
);

export const getAllReportees = createAsyncThunk(
  "taskbox/get_reportees",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getAllReportees : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_reportees";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getAllReportees response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getAllReportees : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);